<template>
  <div class="counter">
    <button @click="minus" class="minus">-</button>
    <input @input="inputValue" v-model="count" type="text"/>
    <button @click="add" class="add">+</button>
  </div>
</template>

<script>
  export default {
    name: "counter",
    data() {
      return {
        count:null
      }
    },
    props:{
      initVal:{
        type:Number,
        default:0
      },
      max:{
        type:Number,
        default:100
      },
      min:{
        type:Number,
        default: 0
      }
    },
    computed: {},
    methods: {
      add(){
        if(this.count>=this.max){
          return false;
        }
        this.count++;
        this.$emit("valueChange",{val:this.count})
      },
      minus(){
        if(this.count<=this.min){
          return false;
        }
        this.count--;
        this.$emit("valueChange",{val:this.count})
      },
      inputValue(){
        if(this.count>this.max){
          this.count=this.max;
        }
        if(this.count<this.min){
          this.count=this.min;
        }
        this.$emit("valueChange",{val:this.count})
      }
    },
    mounted() {
      if(this.initVal){
        this.count=this.initVal
        return
      }
      this.count=this.min

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
.counter
  font-size 0
  line-height 30px
  button
    width 30px
    height 30px
    line-height 26px
    font-size 18px
    color #666666
    border 1px solid #cccccc
    outline none
    background-color #ffffff
    vertical-align top
    transition 300ms
    &:hover
      background-color #eeeeee
    &.add
      border-top-right-radius 5px
      border-bottom-right-radius 5px
    &.minus
      border-top-left-radius 5px
      border-bottom-left-radius 5px

  input
    display inline-block
    vertical-align top
    padding 0 6px
    text-align center
    font-size 12px
    height 30px
    width 40px
    border 1px solid #cccccc
    border-left none
    border-right none


</style>


// WEBPACK FOOTER //
// src/components/globalComp/counter.vue